import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector } from "react-redux";
const useStyles = makeStyles({
  backdrop: {
    zIndex: 99999999999999999,
    color: "#fff",
  },
});
const PreLoader = (props) => {
  const classes = useStyles();
  const loadingCount = useSelector(state=> state.layoutState.loadingCount);

  return (
    <Backdrop
      className={classes.backdrop}
      open={loadingCount > 0}
      onClick={(e) => e.stopPropagation()}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default PreLoader;
